import { styled } from "@mui/material/styles";
import {
  EditButton,
  SaveButton,
  ShowButton,
  TabbedShowLayout,
  TextInput,
  Toolbar,
} from "react-admin";
import { Box, Button, Divider, Select, Table, TextField } from "@mui/material";
import { colors } from "./colors";
import { DatePicker } from "@mui/x-date-pickers";

export const WorkspaceContainer = styled("div")(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.bgPrimary
      : colors.light.bgPrimary,
  padding: "16px",
  flex: 1,


  [theme.breakpoints.down("sm")]: {
    padding: "20px 0px 80px 0px", 
  },
}));

export const WorkspacePanel = styled("div")(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? colors.dark.bgWhite : colors.light.bgWhite,
  padding: "24px",
  borderRadius: "8px",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  width: "100%",

  [theme.breakpoints.down("sm")]: {
    padding: "12px 14px",
  },
}));

export const WhiteBgContainer = styled("div")(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? colors.dark.bgWhite : colors.light.bgWhite,
  borderRadius: "12px",
}));

export const BlueBorderContainer = styled("div")(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  borderBottom:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderPrimary}`
      : `1px solid ${colors.light.borderPrimary}`,
  paddingBottom: '20px',
  marginBottom: '20px',

  [theme.breakpoints.down("sm")]: {
    flexWrap: 'wrap',
    gap: '12px',
  },
}))

export const BlueTOpBorderContainer = styled("div")(({theme}) => ({
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center', 
  borderTop:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderPrimary}`
      : `1px solid ${colors.light.borderPrimary}`,
  paddingTop: '20px', 
  marginTop: '10px'
}))

export const InlineSpaceBetweenContainer = styled("div")(({theme}) => ({
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center', 
  width: '100%',
}))

export const WorkspaceHeader = styled("div")(({ theme }) => ({
  // backgroundImage:
  //   theme.palette.mode === "dark"
  //     ? `url(colors.dark.bgSecondary)`
  //     : `url(colors.light.bgSecondary)`,
  backgroundColor:
    theme.palette.mode === "dark" ? colors.dark.bgWhite : colors.light.bgWhite,
  padding: "16px 24px",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "12px",
  border:
    theme.palette.mode === "dark"
      ? "1px solid rgb(45, 54, 67)"
      : "1px solid rgba(25, 117, 210, 0.1)",
  marginBottom: "20px",

  [theme.breakpoints.down("md")]: {
    padding: "14px 16px",
    gap: "12px",
  },

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "12px 14px",
    gap: "12px",
    borderRadius: "6px",
  },
}));

export const WorkspaceHeaderMeta = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
}));

export const ButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",

  [theme.breakpoints.down("sm")]: {
    alignItems: "flex-start",
    width: "100%",
  },
}));

export const HeaderMetaItem = styled("p")(({ theme }) => ({
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "14px",
  margin: 0,
}));

export const HeaderMetaGroup = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  borderRight: "1px solid rgb(226, 230, 233)",
  paddingRight: "12px",

  [theme.breakpoints.down("sm")]: {
    borderBottom: "1px solid rgb(226, 230, 233)",
    borderRight: "none",
    paddingBottom: "4px",
    width: "100%",
  },
}));

export const HeaderMetaLabel = styled("span")(({ theme }) => ({
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,
}));

export const WorkspaceSection = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "20px",

  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    borderBottom: "1px solid rgb(226, 230, 233)",
    paddingBottom: "12px",
    marginBottom: "12px",
  },
}));

export const SectionHeader = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const WorkspaceTitle = styled("h2")(({ theme }) => ({
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "20px",
  padding: "0px",
  margin: 0,

  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}));

export const WorkspaceShowButton = styled(ShowButton)(({ theme }) => ({
  textTransform: "none",
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.bgButtonlight
      : colors.light.bgButtonlight,
  border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderSecondary}`
      : `1px solid ${colors.light.borderSecondary}`,
  borderRadius: "6px",
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textSecondary
      : colors.light.textSecondary,
  padding: "8px 16px 6px 16px",
  fontSize: "14px",
  fontWeight: 500,

  "&:hover": {
    backgroundColor: "rgb(232, 235, 238)",
    borderColor: "rgb(210, 216, 222)",
    color: "rgb(36, 48, 64)",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "2px 8px",
    borderRadius: "4px",

    "& svg": {
      width: "16px",
      height: "16px",
    },
  },
}));

export const SectionTitle = styled("h3")(({ theme }) => ({
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "18px",
  padding: "0px",
  margin: 0,

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const SectionTitleSecondary = styled("h3")(({ theme }) => ({
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "18px",
  padding: "0px",
  margin: 0,
  fontWeight: "500",

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const WorkspaceSubtitle = styled("p")(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontSize: "14px",
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export const ColGapLine = styled("div")(({ theme }) => ({
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,
  padding: "0px 6px",
}));

export const SectionTitleRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",

  [theme.breakpoints.down("sm")]: {
    gap: "10px",
    borderBottom: "1px solid rgb(226, 230, 233)",
    width: "100%",
    paddingBottom: "8px",
  },
}));

export const WorkSpaceTitleRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",

  [theme.breakpoints.down("sm")]: {
    gap: "10px",
  },
}));

export const WorkspaceIconBadge = styled("div")({
  backgroundColor: "rgba(25, 117, 210, 0.9)",
  padding: "10px 8px",
  borderRadius: "8px",
});

export const FormGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "16px",
  width: "100%",
  marginTop: "20px",

  [theme.breakpoints.down("md")]: {
    gap: "14px",
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
    gap: "12px",
    marginTop: "16px",
  },
}));

export const FormFieldGroup = styled("div")({
  width: "100%",
});

export const FormLabel = styled("p")(({ theme }) => ({
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "14px",
  fontWeight: "500",
  margin: 0,
  marginBottom: "2px",

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export const StyledTextInput = styled(TextInput)(({ theme }) => ({
  "& .MuiFormHelperText-root": {
    display: "none",
  },

  "& .MuiOutlinedInput-root": {
    padding: 0,

    "& fieldset": {
      display: "none",
    },
    "&:hover fieldset": {
      display: "none",
    },
    "&.Mui-focused fieldset": {
      display: "none",
    },
  },

  "& .MuiInputBase-input": {
    border:
      theme.palette.mode === "dark"
        ? `1px solid ${colors.dark.borderInputField}`
        : `1px solid ${colors.light.borderInputField}`,
    borderRadius: "6px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? colors.dark.bgInputField
        : colors.light.bgInputField,
    padding: "12px 14px",
    fontSize: "14px",
    color:
      theme.palette.mode === "dark"
        ? colors.dark.textBlack
        : colors.light.textBlack,
    transition: "all 0.2s ease",

    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark" ? colors.dark.bgInputField : "#F1F3F5",
    },

    "&:focus": {
      backgroundColor:
        theme.palette.mode === "dark" ? colors.dark.bgInputField : "#fff",
      borderColor: "#1976d2",
      boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.1)",
    },

    [theme.breakpoints.down("md")]: {
      padding: "10px 12px",
      fontSize: "13.5px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "8px 10px",
      fontSize: "13px",
    },
  },
}));

export const StyledInputButton = styled(Button)(({ theme }) => ({
  border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  borderRadius: "6px",
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  padding: "10px 14px",
  fontSize: "14px",
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  transition: "all 0.2s ease",
  marginTop: "8px",
  fontWeight: "normal",

  "&:hover": {
    backgroundColor:
      theme.palette.mode === "dark" ? colors.dark.bgInputField : "#F1F3F5",
  },

  "&:focus": {
    backgroundColor:
      theme.palette.mode === "dark" ? colors.dark.bgInputField : "#fff",
    borderColor: "#1976d2",
    boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.1)",
  },

  [theme.breakpoints.down("md")]: {
    padding: "10px 12px",
    fontSize: "13.5px",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "8px 10px",
    fontSize: "13px",
  },
}));

export const StyledDateText = styled(TextField)(({theme}) => ({
  margin: 0,
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    padding: "2px 14px",
    backgroundColor: theme.palette.mode === "dark" ? colors.dark.bgInputField : colors.light.bgInputField,
    "& fieldset": {
      border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
    },
    "&:hover fieldset": {
      border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      boxShadow: "0 0 0 3px rgba(25,118,210,0.1)",
      border: 'inherit',
    },
  },
  "& input": {
    padding: "12px 14px",
    fontSize: "14px",
  },
}))

export const StyledSelect = styled(Select)(({ theme }) => ({
  border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  borderRadius: "6px",
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  padding: "0",

  "& .MuiSelect-select": {
    padding: "12px 14px",
    fontSize: "14px",
    color:
      theme.palette.mode === "dark"
        ? colors.dark.textBlack
        : colors.light.textBlack,
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("md")]: {
      padding: "10px 12px",
      fontSize: "13.5px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "8px 10px",
      fontSize: "13px",
    },
  },

  "& fieldset": {
    display: "none",
  },

  "&:hover": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? colors.dark.bgInputField
        : "#F1F3F5",
  },

  "&.Mui-focused": {
    backgroundColor:
      theme.palette.mode === "dark" ? colors.dark.bgInputField : "#fff",
    boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.1)",
  },
}));


export const StyledDateInput = styled(DatePicker)(({ theme }) => ({
  border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  borderRadius: "6px",
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  padding: "0",


}));


export const Paragraph = styled("p")(({ theme }) => ({
  margin: "0",
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
}));

export const WorkspaceActionBar = styled(Toolbar)(({ theme }) => ({
  marginTop: "24px",
  backgroundColor:
    theme.palette.mode === "dark" ? colors.dark.bgWhite : colors.light.bgWhite,
  padding: "24px",
  borderRadius: "8px",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "12px",

  [theme.breakpoints.down("md")]: {
    padding: "20px",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "16px",
    justifyContent: "stretch",
  },
}));

export const PrimaryActionButton = styled(SaveButton)(({ theme }) => ({
  textTransform: "none",
  padding: "8px 20px",
  fontSize: "14px",
  fontWeight: 500,
  backgroundColor: "#1976d2 !important",
  color: "#fff !important",

  "&:hover": {
    backgroundColor: "#1565c0 !important",
  },

  [theme.breakpoints.down("md")]: {
    padding: "8px 18px",
  },

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "4px 16px",
    fontSize: "14px",
  },
}));

export const StatusToggleSwitch = styled("div")(
  ({ theme, active }: { theme?: any; active: boolean }) => ({
    position: "relative",
    display: "inline-block",
    width: "40px",
    height: "20px",
    margin: "0 8px",
    verticalAlign: "middle",
    "& input": {
      opacity: 0,
      width: 0,
      height: 0,
    },
    "& .slider": {
      position: "absolute",
      cursor: "pointer",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: active
        ? "#1976d2"
        : theme.palette.mode === "dark"
        ? colors.dark.bgTeritary
        : colors.light.bgTeritary,
      transition: ".4s",
      borderRadius: "34px",
      "&:before": {
        position: "absolute",
        content: '""',
        height: "16px",
        width: "16px",
        left: "2px",
        bottom: "2px",
        backgroundColor: active ? "#fff" : "#9E9E9E",
        transition: ".4s",
        borderRadius: "50%",
        transform: active ? "translateX(20px)" : "translateX(0)",
      },
    },
  })
);

export const ResponsiveLocationIcon = styled("svg")(({ theme }) => ({
  width: "18px",
  height: "18px",
  color: "#1976d2",
  display: "block",

  [theme.breakpoints.down("sm")]: {
    width: "14px",
    height: "14px",
  },
}));

//Show Styles

export const ShowTabsContainer = styled(TabbedShowLayout)(({ theme }) => ({
  "& .RaTabbedShowLayout-content": {
    padding: 0,
    border: "none",
  },

  "& .MuiTabs-root": {
    marginBottom: "16px",
    paddingBottom: "6px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? colors.dark.bgWhite
        : colors.light.bgWhite,
    borderRadius: "12px",
    scrollbarWidth: "thin",
    scrollbarColor: "#B6C2D1",
  },

  "& .MuiTabs-root::-webkit-scrollbar": {
    height: "6px",
  },
  "& .MuiTabs-root::-webkit-scrollbar-track": {
    background: "#EEF2F6",
    borderRadius: "10px",
  },
  "& .MuiTabs-root::-webkit-scrollbar-thumb": {
    backgroundColor: "#B6C2D1",
    borderRadius: "10px",
  },
  "& .MuiTabs-root::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#9AA9BC",
  },

  "& .MuiDivider-root": {
    display: "none",
  },
}));

export const HorizontalLine = styled("hr")(({theme}) => ({
  border: 'none',
  height: '1px',
  backgroundColor: theme.palette.mode === "dark" ? colors?.dark?.borderLight : colors?.light?.borderLight,
  margin: '16px 0',
}))

export const ThreeColGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: "16px",
  width: "100%",
  marginTop: "20px",

  [theme.breakpoints.down("md")]: {
    gap: "14px",
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
    gap: "12px",
    marginTop: "16px",
  },
}));

export const TwoColGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "4fr 6fr",
  gap: "16px",
  width: "100%",
  marginTop: "20px",

  [theme.breakpoints.down("md")]: {
    gap: "14px",
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
    gap: "12px",
    marginTop: "16px",
  },
}));

export const HeaderSubMetaLabel = styled("span")(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#fff" : "#268723",
  fontSize: "14px",
  fontWeight: "bold",
}));

export const ShowItemCOntainer = styled("div")(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  borderRadius: "6px",
  padding: "16px",
}));

export const ShowLabel = styled("p")(({ theme }) => ({
  color: "rgb(101, 117, 139)",
  fontSize: "14px",
  margin: "0px",
  marginBottom: "6px",
}));

export const ShowValue = styled("p")(({theme}) => ({
  margin: "0",
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: '14px',    
}))

export const FlexBetween = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const ShowScrollHoldContainer = styled("div")(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.bgPrimary
      : colors.light.bgPrimary,
  padding: "0px",
  border: "none",
}));

export const WorkspaceEditButton = styled(EditButton)(({ theme }) => ({
  textTransform: "none",
  border: "1px solid rgba(25, 117, 210, 0.9)",
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.outlineButtonBg
      : colors.light.outlineButtonBg,
  color: "rgba(25, 117, 210, 0.9)",
  borderRadius: "6px",
  padding: "6px 12px",
  fontSize: "14px",
  fontWeight: 500,
  boxShadow: "none",

  "&:hover": {
    backgroundColor: "rgba(25, 117, 210, 0.9)",
    color: "#fff",
    boxShadow: "none",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "2px 8px",
    borderRadius: "4px",

    "& svg": {
      width: "16px",
      height: "16px",
    },
  },
}));

export const MapHeaderContainer = styled("div")(({ theme }) => ({
  border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderPrimary}`
      : `1px solid ${colors.light.borderPrimary}`,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px",
  borderRadius: "12px 12px 0px 0px",
}));

export const MapButton = styled(Button)(({ theme }) => ({
  border: "1px solid rgba(25, 117, 210, 0.9)",
  fontSize: "12px",
  padding: "4px 16px",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(25, 117, 210, 0.9)"
      : "rgba(25, 117, 210, 0.1)",
  zIndex: "100",

  "&:hover": {
    backgroundColor: "rgba(25, 117, 210, 0.9)",
    color: "#fff",
    boxShadow: "none",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "2px 8px",
    borderRadius: "4px",

    "& svg": {
      width: "16px",
      height: "16px",
    },
  },
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  border: "1px solid rgba(25, 117, 210, 0.9)",
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.outlineButtonBg
      : colors.light.outlineButtonBg,
  color: "rgba(25, 117, 210, 0.9)",
  fontSize: "14px",
  boxShadow: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  padding: "4px 12px",
  textTransform: "none",

  "&:hover": {
    backgroundColor: "rgba(25, 117, 210, 0.9)",
    color: "#fff",
    boxShadow: "none",

    "& svg": {
      color: "#fff",
    },
  },

  "& svg": {
    width: "16px",
    height: "16px",
    color: "rgba(25, 117, 210, 0.9)",
  },
}));


export const OutlinedDelButton = styled(Button)(({ theme }) => ({
  border: "1px solid red",
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.outlineButtonBg
      : colors.light.outlineButtonBg,
  color: "red",
  fontSize: "14px",
  boxShadow: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  padding: "4px 12px",
  textTransform: "none",

  "&:hover": {
    backgroundColor: "red",
    color: "#fff",
    boxShadow: "none",

    "& svg": {
      color: "#fff",
    },
  },

  "& svg": {
    width: "16px",
    height: "16px",
    color: "red",
  },
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  //border: "1px solid rgba(25, 117, 210, 0.9)",
  backgroundColor: "rgba(25, 117, 210, 0.9)",
  color: "#fff",
  fontSize: "14px",
  boxShadow: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  padding: "4px 12px",
  textTransform: "none",

  "&:hover": {
    backgroundColor: "rgba(25, 117, 210, 0.9)",
    color: "#fff",
    boxShadow: "none",
  },

  "& svg": {
    width: "16px",
    height: "16px",
    color: "rgba(25, 117, 210, 0.9)",
  },
}));

export const GreenBadgeSquare = styled("p")(({ theme }) => ({
  color: "#268723",
  backgroundColor: "rgba(38, 135, 35, .2)",
  border: "1px solid #268723",
  margin: "0",
  padding: "2px 12px",
  borderRadius: "4px",
  marginBottom: "10px",
  textAlign: "center",
}));

export const DividerPrimary = styled(Divider)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? colors.dark.borderSecondary
      : "rgb(226, 230, 233)",
  my: 1.5,
}));

//Table View

export const TableWrapper = styled("div")(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? colors.dark.bgWhite : colors.light.bgWhite,
  borderRadius: "8px",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  width: "100%",
  display: 'flex',
  flexDirection: 'column',


  [theme.breakpoints.down("sm")]: {
    padding: "12px 14px",
  },
}));
export const BackButton = styled("button")({
  display: "flex",
  alignItems: "center",
  background: "none",
  border: "none",
  cursor: "pointer",
  marginBottom: "16px",
  color: "#1976d2",
  fontSize: "1rem",
  "&:hover": {
    textDecoration: "underline",
  },
});

export const TableTopHeader = styled("div")(({ theme }) => ({
  padding: "16px 24px",
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const HorizontalTableTopHeader = styled("div")({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: "24px 24px",
})

export const HorizontalContainer = styled("div")({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const Title = styled("h3")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  margin: "0",
  color:
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
}));

export const Card = styled("div")({
  backgroundColor: "#fff",
  borderRadius: "8px",
  border: "1px solid #e0e0e0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  padding: "16px",
  height: "100%",
});
export const CardTitle = styled("h2")({
  fontSize: "1.25rem",
  marginBottom: "16px",
  color: "#1a1a1a",
});

export const TableHeader = styled("td")(({ theme }) => ({
  padding: "12px 16px",
  textAlign: "left",
  fontWeight: 500,
  fontSize: "14px",
  color:
    theme.palette.mode === "dark"
      ? colors.dark.tableHeader
      : colors.light.tableHeader,
}));

export const TableData = styled("td")(({ theme }) => ({
  padding: "12px 16px",
  fontSize: "14px",
}));

export const CustomTableRowTR = styled("tr")(({ theme }) => ({
  borderBottom:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.tableBorder}`
      : `1px solid ${colors.light.tableBorder}`,
  backgroundColor:
    theme.palette.mode === "dark"
      ? `var(--row-bg, ${colors.dark.bgWhite}) !important`
      : `var(--row-bg, ${colors.light.bgWhite}) !important`,
  padding: "8px 0 !important",    
  "&:hover": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? `${colors.dark.tableBgHover} !important`
        : `${colors.light.tableBgHover} !important`,
    cursor: "pointer",
  },

  "&:active": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? `${colors.dark.tableBgHover} !important`
        : `${colors.light.tableBgHover} !important`,
  },
  transition: "background-color 0.2s ease-in-out",
}));

//End Table View

export const InlineContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "4px",
}));

//Filter container

export const TabsContainer = styled(Box)(({theme}) => ({
   backgroundColor:
    theme.palette.mode === "dark" ? colors.dark.bgWhite : colors.light.bgWhite,
    borderBottom: 1, 
    borderColor: 'divider',
    display: 'flex',
    alignItems: 'center',
}))

export const FilterWrapper = styled("div")(({ theme }) => ({
  border:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderTeritary}`
      : `1px solid ${colors.light.borderTeritary}`,
  borderRadius: "12px",
  backgroundColor:
    theme.palette.mode === "dark" ? colors.dark.bgWhite : colors.light.bgWhite,
  position: "sticky",
  top: 0,
  zIndex: 100,
  // On phones the whole page scrolls, so let the filter scroll away with
  // the content instead of staying pinned to the top. The ::after band only
  // exists to mask rows sliding under the sticky filter on desktop, so hide
  // it here to remove the extra grey strip below the filter.
  [theme.breakpoints.down("sm")]: {
    position: "static",
    "&::after": {
      display: "none",
    },
  },
  "&::after": {
    content: '""',
    display: "block",
    position: "absolute",
    bottom: "-12px",
    left: 0,
    right: 0,
    height: "12px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? colors.dark.bgPrimary
        : colors.light.bgPrimary,
  },
}));

export const FIlterHeader = styled("div")(({ theme }) => ({
  borderBottom:
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderTeritary}`
      : `1px solid ${colors.light.borderTeritary}`,
  padding: "8px 16px",
  borderTopLeftRadius: "12px",
  borderTopRightRadius: "12px",
  backgroundColor: theme.palette.mode === "dark" ? colors.dark.filterBg : colors.light.filterBg,
}));

export const FilterSection = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "20px",

  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    marginBottom: "12px",
  },
}));

export const FilterContainer = styled("div")(({ theme }) => ({
  padding: "8px 16px",
  borderBottomRightRadius: "12px",
  borderBottomLeftRadius: "12px",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",

  [theme.breakpoints.down("sm")] : {
    flexWrap: "wrap",
    rowGap: "8px",
    "& > *": {
      width: "100%",
    },
  }
}));

export const FilterInput = styled(TextField)(({ theme }) => ({
  "& .MuiFormHelperText-root": {
    display: "none",
  },

  "& .MuiOutlinedInput-root": {
    padding: 0,

    "& fieldset": {
      display: "none",
    },
    "&:hover fieldset": {
      display: "none",
    },
    "&.Mui-focused fieldset": {
      display: "none",
    },
  },
  "& .MuiInputBase-input": {
    border: theme.palette.mode === "dark" ? `1px solid ${colors.dark.borderTeritary}` : `1px solid ${colors.light.borderTeritary}`,
    borderRadius: "8px",
    backgroundColor: theme.palette.mode === "dark" ? colors.dark.bgInputField : colors.light.bgInputField,
    padding: "8px 12px",
  },

  [theme.breakpoints.down("sm")] : {
    width: "100%",
  }
}));

export const FilterTextField = styled(TextField)(({ theme }) => ({
  "& .MuiFormHelperText-root": {
    display: "none",
  },

  "& .MuiInputBase-root": {
    borderRadius: "12px",
    padding: "0",

    "& ::before": {
      border: "none",
    },
  },

  "& .MuiButtonBase-root": {
    
  },

  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: theme.palette.mode === "dark" ? colors.dark.bgInputField : colors.light.bgInputField,
    paddingLeft: "12px",
    paddingRight: "12px",
    "& fieldset": {
      borderColor: theme.palette.mode === "dark" ? colors.dark.borderTeritary : colors.light.borderTeritary,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.mode === "dark" ? colors.dark.borderTeritary : colors.light.borderTeritary,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.mode === "dark" ? colors.dark.borderTeritary : colors.light.borderTeritary,
      borderWidth: "1px",
    },
  },
  "& .MuiInputBase-input": {

  },

  [theme.breakpoints.down("sm")] : {
    width: "100%",
    minWidth: "0 !important",
  }
}));

export const FilterSelectEl = styled(Select)(({ theme }) => ({
  minWidth: "200px",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    minWidth: 0,
  },

  "& .MuiFormHelperText-root": {
    display: "none",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  "& .MuiInputBase-root": {
    borderRadius: "12px",
    padding: "0",

    "& ::before": {
      border: "none",
    },
  },

  "& .MuiButtonBase-root": {
  display: "none",
},
  
  "& .MuiOutlinedInput-root": {
    padding: 0,

    "& fieldset": {
      display: "none",
    },
    "&:hover fieldset": {
      display: "none",
    },
    "&.Mui-focused fieldset": {
      display: "none",
    },
  },
  "& .MuiInputBase-input": {
    border: theme.palette.mode === "dark" ? `1px solid ${colors.dark.borderTeritary}` : `1px solid ${colors.light.borderTeritary}`,
    borderRadius: "8px",
    backgroundColor: theme.palette.mode === "dark" ? colors.dark.bgInputField : colors.light.bgInputField,
    paddingLeft: "12px",
    paddingRight: "12px",
  },
  "& .MuiInputLabel-root": {
    color: theme.palette.mode === "dark" ? colors.dark.textGrey : colors.light.textGrey,
    fontSize: "14px",
    transform: "translate(14px, 10px) scale(1)",
    "&.Mui-focused": {
      color: "#1976d2",
    },
    "&.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
  },
}));


export const StyledTable = styled(Table)({
  tableLayout: 'auto',
  width: '100%',
  '& th, & td': {
    whiteSpace: 'nowrap',
    padding: '8px 16px',
  },
  '& .MuiTableCell-root': {
    overflow: 'visible',
    textOverflow: 'ellipsis', 
  }
});

export const SixColTwoRowGrid = styled("div")(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '24px',

  '& > div': {
    minWidth: 0,
    overflowWrap: 'anywhere',
  },

  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
  },
}))

export const ThreeColNRowGrid = styled("div")(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '24px',
}))

export const FiveColGrid = styled("div")(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: '24px',
}))


//Timeline

export const TimelineWrapper = styled("div")({
  position: "relative",
  padding: "32px 48px",
  width: "100%",
});

export const TimelineLine = styled("div")(({theme}) => ({
  position: "absolute",
  top: "38px",
  left: "48px",
  right: "48px",
  height: "2px",
  backgroundColor: theme.palette.mode === "dark" ? colors.dark.borderSecondary : colors.light.borderSecondary,
}));

export const TimelineItemsWrapper = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  position: "relative",
});

export const TimelineItemsInnerWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minWidth: "120px",
});

export const TimelineDot = styled("div")({
  width: "14px",
  height: "14px",
  borderRadius: "50%",
  marginBottom: "8px",
  zIndex: 1,
});

export const TimelineTimeEL = styled("div")(({theme}) => ({
  fontSize: "14px",
  fontWeight: 600,
  color: theme.palette.mode === "dark" ? colors.dark.textBlack : colors.light.textBlack,
  marginBottom: "4px",
}));

export const TimelineTextEL = styled("div")(({theme}) => ({
  fontSize: "13px",
  color:  theme.palette.mode === "dark" ? colors.dark.textGrey : colors.light.textGrey,
  whiteSpace: "nowrap",
}));

export const WorkspacePanelsWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
  width: "100%",

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const LeftWorkspacePanel = styled("div")(({ theme }) => ({
  flex: 3,
  // Allow the flex item to shrink below its content's intrinsic width so a
  // wide child (e.g. the 920px Book By Dish dishes table) scrolls inside its
  // own container instead of pushing the right-side cards off-screen.
  minWidth: 0,
}));

export const RightWorkspacePanel = styled("div")(({ theme }) => ({
  flex: 1.2,
  minWidth: "320px",

  [theme.breakpoints.down("md")]: {
    minWidth: "100%",
  },
}));

export const RedBadge = styled("div")(({theme}) => ({
  color: 'rgb(185, 28, 28)',
  backgroundColor: 'rgba(254, 226, 226)',
  padding: '2px 12px',
  fontSize: '12px',
  fontWeight: '500',
  borderRadius: '100px',
}))

export const StatusBooleanBadge = styled("div")<{
  active?: boolean;
}>(({ active }) => ({
  color: active ? "rgb(21, 128, 61)" : "rgb(185, 28, 28)",
  backgroundColor: active
    ? "rgb(220, 252, 231)"
    : "rgb(254, 226, 226)",
  padding: "2px 12px",
  fontSize: "12px",
  fontWeight: 500,
  borderRadius: "100px",
  whiteSpace: "nowrap",
}));


export const InfoPill = styled("div")(({theme}) => ({
  display: 'flex', 
  alignItems: 'center', 
  gap: '8px', 
  padding: "8px 12px", 
  borderRadius: '8px', 
  backgroundColor: "rgb(239, 246, 255)",
  border: '1px solid rgb(101, 117, 139, 0.1)'
}))


export const HighlightValue = styled("p")(({theme}) => ({
  color: colors.primaryDark, 
  fontSize: '18px', 
  fontWeight: '700', 
  margin: '0'
}))

export const JsonViewerContainer = styled("div")(({ theme }) => ({
  backgroundColor: 
    theme.palette.mode === "dark" 
      ? colors.dark.bgInputField 
      : colors.light.bgInputField,
  borderRadius: "8px",
  padding: "16px",
  maxHeight: "55vh",
  overflow: "auto",
  border: 
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  fontFamily: '"JetBrains Mono", "Fira Code", "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
  fontSize: "12px",
  lineHeight: "1.5",
  letterSpacing: "0.2px",
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,

  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: 
      theme.palette.mode === "dark"
        ? colors.dark.borderSecondary
        : colors.light.borderSecondary,
    borderRadius: "4px",
    border: 
      theme.palette.mode === "dark"
        ? `2px solid ${colors.dark.bgInputField}`
        : `2px solid ${colors.light.bgInputField}`,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: 
      theme.palette.mode === "dark"
        ? colors.dark.bgInputField
        : colors.light.bgInputField,
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: 
      theme.palette.mode === "dark"
        ? colors.dark.textGrey
        : colors.light.textGrey,
  },

  [theme.breakpoints.down("sm")]: {
    padding: "12px",
    fontSize: "11px",
    maxHeight: "40vh",
  },
}));

export const JsonViewerContent = styled("pre")(({ theme }) => ({
  margin: 0,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "inherit",
  fontFamily: "inherit",
  lineHeight: "inherit",
  letterSpacing: "inherit",
}));

export const JsonViewerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 16px",
  borderBottom: 
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderSecondary}`
      : `1px solid ${colors.light.borderSecondary}`,
  backgroundColor: 
    theme.palette.mode === "dark"
      ? colors.dark.bgWhite
      : colors.light.bgWhite,
  borderRadius: "8px 8px 0 0",

  [theme.breakpoints.down("sm")]: {
    padding: "10px 12px",
  },
}));

export const JsonViewerTitle = styled("h3")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  margin: 0,
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const JsonViewerActions = styled("div")({
  display: "flex",
  gap: "8px",
  alignItems: "center",
});

export const JsonViewerCopyButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 12px",
  border: 
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  borderRadius: "6px",
  backgroundColor: 
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "12px",
  fontWeight: 500,
  cursor: "pointer",
  transition: "all 0.2s ease",
  fontFamily: "inherit",

  "&:hover": {
    backgroundColor: 
      theme.palette.mode === "dark"
        ? colors.dark.bgTeritary
        : colors.light.bgTeritary,
    borderColor: 
      theme.palette.mode === "dark"
        ? colors.dark.borderSecondary
        : colors.light.borderSecondary,
  },

  "&:active": {
    transform: "scale(0.98)",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "4px 8px",
    fontSize: "11px",
  },
}));

export const JsonViewerEmptyState = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "40px 20px",
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,
  fontSize: "14px",
  textAlign: "center",
  backgroundColor: 
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  borderRadius: "8px",
  border: 
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,

  [theme.breakpoints.down("sm")]: {
    padding: "30px 16px",
    fontSize: "13px",
  },
}));

export const JsonViewerEmptyIcon = styled("div")({
  fontSize: "48px",
  marginBottom: "12px",
  opacity: 0.5,
});

export const JsonViewerSyntaxHighlight = styled("span")<{ type: string }>(({ type, theme }) => {
  const syntaxColors = {
    string: 
      theme.palette.mode === "dark"
        ? "#98C379"
        : "#0D7377",
    number: 
      theme.palette.mode === "dark"
        ? "#D19A66"
        : "#D73A49",
    boolean: 
      theme.palette.mode === "dark"
        ? "#56B6C2"
        : "#1976D2",
    null: 
      theme.palette.mode === "dark"
        ? "#ABB2BF"
        : "#6F42C1",
    key: 
      theme.palette.mode === "dark"
        ? "#E06C75"
        : "#E36209",
    bracket: 
      theme.palette.mode === "dark"
        ? "#ABB2BF"
        : "#586069",
  };

  return {
    color: syntaxColors[type as keyof typeof syntaxColors] || syntaxColors.bracket,
  };
});

export const CustomerInstructionsContainer = styled("div")(({ theme }) => ({
  padding: "20px",
  backgroundColor: 
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  borderRadius: "12px",
  border: 
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  minHeight: "80px",
  textAlign: "left",
  transition: "all 0.2s ease",

  [theme.breakpoints.down("sm")]: {
    padding: "16px",
    minHeight: "60px",
  },
}));

export const CustomerInstructionsContent = styled("p")<{ hasContent: boolean }>(({ hasContent, theme }) => ({
  color: hasContent
    ? theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack
    : theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,
  lineHeight: 1.6,
  fontSize: "14px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  margin: 0,
  fontWeight: hasContent ? 400 : 400,

  [theme.breakpoints.down("sm")]: {
    fontSize: "13px",
    lineHeight: 1.5,
  },
}));

export const CustomerInstructionsEmpty = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,
  fontStyle: "italic",
  fontSize: "13px",
  fontWeight: 400,

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    gap: "6px",
  },
}));

export const CustomerInstructionsEmptyIcon = styled("div")(({ theme }) => ({
  fontSize: "16px",
  opacity: 0.6,
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const CustomerInstructionsHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "12px",
  padding: "0 4px",

  [theme.breakpoints.down("sm")]: {
    marginBottom: "10px",
  },
}));

export const CustomerInstructionsMeta = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  fontSize: "12px",
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textGrey
      : colors.light.textGrey,
  fontWeight: 500,

  [theme.breakpoints.down("sm")]: {
    fontSize: "11px",
    gap: "8px",
  },
}));

export const CustomerInstructionsBadge = styled("div")<{ variant: "info" | "warning" | "success" }>(({ variant, theme }) => {
  const variants = {
    info: {
      backgroundColor: 
        theme.palette.mode === "dark"
          ? "rgba(25, 117, 210, 0.2)"
          : "rgba(25, 117, 210, 0.1)",
      color: 
        theme.palette.mode === "dark"
          ? "#64B5F6"
          : "#1976D2",
      border: 
        theme.palette.mode === "dark"
          ? "1px solid rgba(25, 117, 210, 0.3)"
          : "1px solid rgba(25, 117, 210, 0.2)",
    },
    warning: {
      backgroundColor: 
        theme.palette.mode === "dark"
          ? "rgba(245, 124, 0, 0.2)"
          : "rgba(255, 152, 0, 0.1)",
      color: 
        theme.palette.mode === "dark"
          ? "#FFB74D"
          : "#F57C00",
      border: 
        theme.palette.mode === "dark"
          ? "1px solid rgba(245, 124, 0, 0.3)"
          : "1px solid rgba(255, 152, 0, 0.2)",
    },
    success: {
      backgroundColor: 
        theme.palette.mode === "dark"
          ? "rgba(56, 142, 60, 0.2)"
          : "rgba(76, 175, 80, 0.1)",
      color: 
        theme.palette.mode === "dark"
          ? "#81C784"
          : "#4CAF50",
      border: 
        theme.palette.mode === "dark"
          ? "1px solid rgba(56, 142, 60, 0.3)"
          : "1px solid rgba(76, 175, 80, 0.2)",
    },
  };

  return {
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    ...variants[variant],
  };
});

export const CustomerInstructionsActions = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "8px",
  marginTop: "12px",

  [theme.breakpoints.down("sm")]: {
    marginTop: "10px",
    gap: "6px",
  },
}));

export const CustomerInstructionsActionButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 12px",
  border: 
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  borderRadius: "6px",
  backgroundColor: 
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  fontSize: "12px",
  fontWeight: 500,
  cursor: "pointer",
  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: 
      theme.palette.mode === "dark"
        ? colors.dark.bgTeritary
        : colors.light.bgTeritary,
    borderColor: 
      theme.palette.mode === "dark"
        ? colors.dark.borderSecondary
        : colors.light.borderSecondary,
  },

  "&:active": {
    transform: "scale(0.98)",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "4px 8px",
    fontSize: "11px",
  },
}));

export const CustomerInstructionsTextarea = styled("textarea")(({ theme }) => ({
  width: "100%",
  minHeight: "120px",
  padding: "12px",
  border: 
    theme.palette.mode === "dark"
      ? `1px solid ${colors.dark.borderInputField}`
      : `1px solid ${colors.light.borderInputField}`,
  borderRadius: "8px",
  fontSize: "14px",
  lineHeight: "1.5",
  fontFamily: "inherit",
  resize: "vertical",
  backgroundColor: 
    theme.palette.mode === "dark"
      ? colors.dark.bgInputField
      : colors.light.bgInputField,
  color: 
    theme.palette.mode === "dark"
      ? colors.dark.textBlack
      : colors.light.textBlack,
  outline: "none",

  "&::placeholder": {
    color: 
      theme.palette.mode === "dark"
        ? colors.dark.textGrey
        : colors.light.textGrey,
  },

  "&:focus": {
    borderColor: 
      theme.palette.mode === "dark"
        ? colors.dark.borderSecondary
        : colors.light.borderSecondary,
    boxShadow: `0 0 0 3px ${
      theme.palette.mode === "dark"
        ? "rgba(25, 117, 210, 0.1)"
        : "rgba(25, 117, 210, 0.1)"
    }`,
  },

  [theme.breakpoints.down("sm")]: {
    padding: "10px",
    fontSize: "13px",
    minHeight: "100px",
  },
}));

export const StatusBadge = styled("div")<{ variant?: string }>(({ variant }) => {
  const variants: any = {
    veg: {
      color: "rgb(21, 128, 61)",
      backgroundColor: "rgb(220, 252, 231)",
    },
    nonVeg: {
      color: "rgb(185, 28, 28)",
      backgroundColor: "rgb(254, 226, 226)",
    },
    starter: {
      color: "rgb(194, 65, 12)",
      backgroundColor: "rgb(255, 237, 213)",
    },
    mainCourse: {
      color: "rgb(29, 78, 216)",
      backgroundColor: "rgb(219, 234, 254)",
    },
    dessert: {
      color: "rgb(190, 24, 93)",
      backgroundColor: "rgb(252, 231, 243)",
    },
    sideDish: {
      color: "rgb(13, 148, 136)",
      backgroundColor: "rgb(204, 251, 241)",
    },
    beverage: {
      color: "rgb(126, 34, 206)",
      backgroundColor: "rgb(243, 232, 255)",
    },
  };

  return {
    display: "inline-block",
    padding: "2px 12px",
    fontSize: "12px",
    fontWeight: 500,
    borderRadius: "100px",
    ...variants[variant || ""],
  };
});

export const DishGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr) 1.2fr",
  gap: "20px",
  marginTop: "24px",

  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const EmptyView = styled("div")(({theme}) => ({
  textAlign: "center",
  borderRadius: '8px',
  padding: "8px",
  backgroundColor:
      theme.palette.mode === "dark"
        ? colors.dark.bgInputField
        : colors.light.bgInputField,
  border:
      theme.palette.mode === "dark"
        ? `1px solid ${colors.dark.borderInputField}`
        : `1px solid ${colors.light.borderInputField}`,      
}))
